import React from "react";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { MenuItem, Select } from "@mui/material";




export default function NewsFilter({ title = "Filters", newsList, setFilteredList }) {
    const { t } = useTranslation()

    const [search, setSearch] = useState("");



    useEffect(() => {
        if (search) {
            applyFilter()
        } else {
            setFilteredList(newsList)
        }
    }, [search])


    const applyFilter = () => {
        let result = newsList;



        result = filterSearch(result)


        setFilteredList(result)
    }






    const filterSearch = (array) => {
        if (search) {
            return array.filter((news) => {
                return (
                    news.titre
                        .toLowerCase()
                        .includes(search.toLowerCase()) ||
                    news.description
                        .toLowerCase()
                        .includes(search.toLowerCase())
                );
            })
        } else {
            return array;
        }
    };







    return (
        <div className="col-md-3">
            <div className="d-flex align-items-center justify-content-center">

                <div className="filtre-marketplace">
                    <div className="filter-header">{title}</div>

                    <div className="marketplace-search-position has-search">
                        <i className="fa fa-search form-control-feedback"></i>
                        <input
                            type="text"
                            className="form-control input-search-marketplace"
                            placeholder={t("catalog3.1")}
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}










export function NewsOrder({ items, setOrderedItems }) {
    const { t } = useTranslation()
    const [order, setOrder] = useState(0)


    useEffect(() => {
        onChangeOrder(order)
    }, [items])



    const onChangeOrder = (value) => {
        let orderedItems = []


        if ([0, 1].includes(value)) {
            // date order
            orderedItems = [...items].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
        }


        // reverse if not ascending order
        if ([1].includes(value)) {
            orderedItems.reverse()
        }

        setOrder(value)
        setOrderedItems(orderedItems)
    }


    return (
        <div className="col-md-12">
            <div className="section-title seemore endsection">
                <div className="plus">
                    <div >
                        <span className="text-input">{t('catalog1.1')}</span>
                    </div>
                    <div>
                        <Select IconComponent={SwapVertIcon} value={order} onChange={(e) => { onChangeOrder(e.target.value) }} fullWidth >
                            <MenuItem value={0}>
                                {t("newestToOldest")}
                            </MenuItem>
                            <MenuItem value={1}>
                                {t("oldestToNewest")}
                            </MenuItem>
                        </Select>

                        
                    </div>
                </div>
            </div>
        </div>
    )
}